import { MouseEventHandler } from 'react';
import { FUNCTIONARIES_SWITCHBOARD_EDIT } from '../../../../../../routes/paths';
import { asyncDeleteFunctionariesSwitch } from '../../../../../../services/functionaries-switch.service';
import Swal from 'sweetalert2';

export const useFunctionariesSwitchboardListActions = (
    id: string,
    onDelete?: () => void
) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${FUNCTIONARIES_SWITCHBOARD_EDIT}/${id}`, '_blank');
    };

    const handleDelete: MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.stopPropagation();
        const result = await Swal.fire({
            title: 'Eliminar registro',
            text: '¿Está seguro de eliminar este registro?, Solo podrá ser activado nuevamente por un administrador',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#757575',
        });

        if (result.isConfirmed) {
            try {
                await asyncDeleteFunctionariesSwitch(id);
                if (onDelete) onDelete();
            } catch (error) {}
        }
    };

    return {
        handleEdit,
        handleDelete,
    };
};
